import styled, { css } from 'styled-components';

export const WrapperHeaderCheckbox = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-wrap: wrap-reverse;
    align-items: center;
    padding: ${theme.spacing.km6} 0 0 0;
    gap: ${theme.spacing.km4};
    background-color: ${theme.color.background.neutral.default};

    div {
      flex-grow: 1;
    }

    @media screen and (max-width: ${theme.breakpoint.md.maxWidth}) {
      padding: ${theme.spacing.km6};
    }

    @media screen and (max-width: ${theme.breakpoint.sm.maxWidth}) {
      box-sizing: border-box;
      padding: ${theme.spacing.km4};
      flex-direction: row-reverse;
      flex-direction: inherit;
    }
  `}
`;
